import React from 'react'

import { withLayout } from '@at/sauron-platform-core'
import { SkeletonSearchListings } from '../../patterns/search-listings/search-listings.skeleton'

import { GlobalStyle, StyledSearchResults } from './search-results.styles'
import { Form } from '../../forms/hocs/form.context'
import { FormState } from '../../forms/hocs/form.state'
import { Header } from '../../header'
import { Footer } from '../../components/footer/footer'
import { SkeletonPills } from '../pills-skeleton'
import { SearchPage } from '../../forms/hocs/search-page.context'
import { SkeletonResultsCountAndSaveSearchSection } from './restults-count-and-save-search-skeleton'

const SkeletonSearchResultsPage = () => {
    return (
        <SearchPage isSkeletonPage={true}>
            <Form>
                <GlobalStyle />
                <StyledSearchResults>
                    <FormState>
                        <SkeletonPills />
                        <SkeletonResultsCountAndSaveSearchSection />
                        <SkeletonSearchListings />
                    </FormState>
                </StyledSearchResults>
            </Form>
        </SearchPage>
    )
}

export const SkeletonSearchResultsPageWithLayout = withLayout(SkeletonSearchResultsPage, {
    HeaderComponent: Header,
    FooterComponent: Footer,
    mainClassName: 'search-results-container',
})
